export const GET_MESSAGE_COUNT_SUCCESS = "GET_MESSAGE_COUNT_SUCCESS";
export const GET_MESSAGE_COUNT_REQUEST = "GET_MESSAGE_COUNT_REQUEST";
export const GET_MESSAGE_COUNT_FAILURE = "GET_MESSAGE_COUNT_FAILURE";
export const getMessageCountSuccess = (payload) => ({
    type: GET_MESSAGE_COUNT_SUCCESS,
    payload,
});
export const getMessageCountRequest = () => ({
    type: GET_MESSAGE_COUNT_REQUEST,
});
export const getMessageCountFailure = (payload) => ({
    type: GET_MESSAGE_COUNT_FAILURE,
    payload,
});
